import React from 'react';

import './contact-info.styles.scss';

const ContactInfo = () => (
	<div className='contact-info'>
		<span>Martinez de Navarrete 610-A, Las Fuentes</span>
		<span>Zamora, Michoacan</span>
		<span>(+52) 33 2325 3831</span>
		<span>contacto@ehueda.com</span>
	</div>
);

export default ContactInfo;